export default [
  {
    positions: [
      [
        [0, 0],
        [1, 0],
        [-1, 0],
        [0, -1]
      ],
      [
        [0, 0],
        [0, -1],
        [0, 1],
        [1, 0]
      ],
      [
        [0, 0],
        [0, 1],
        [-1, 0],
        [1, 0]
      ],
      [
        [0, 0],
        [0, 1],
        [0, -1],
        [-1, 0]
      ]
    ]
  },
  {
    positions: [
      [
        [0, 0],
        [0, -1],
        [0, 1],
        [1, 1]
      ],
      [
        [0, 0],
        [-1, 0],
        [1, 0],
        [-1, 1]
      ],
      [
        [0, 0],
        [0, 1],
        [0, -1],
        [-1, -1]
      ],
      [
        [0, 0],
        [1, 0],
        [-1, 0],
        [1, -1]
      ]
    ]
  },
  {
    positions: [
      [
        [0, 0],
        [0, 1],
        [0, -1],
        [-1, 1]
      ],
      [
        [0, 0],
        [1, 0],
        [-1, 0],
        [-1, -1]
      ],
      [
        [0, 0],
        [0, 1],
        [0, -1],
        [1, -1]
      ],
      [
        [0, 0],
        [-1, 0],
        [1, 0],
        [1, 1]
      ]
    ]
  },
  {
    positions: [
      [
        [0, 0],
        [1, 0],
        [0, -1],
        [1, -1]
      ],
      [
        [0, 0],
        [1, 0],
        [0, -1],
        [1, -1]
      ],
      [
        [0, 0],
        [1, 0],
        [0, -1],
        [1, -1]
      ],
      [
        [0, 0],
        [1, 0],
        [0, -1],
        [1, -1]
      ]
    ]
  },
  {
    positions: [
      [
        [0, 0],
        [0, -1],
        [0, -2],
        [0, 1]
      ],
      [
        [0, 0],
        [1, 0],
        [2, 0],
        [-1, 0]
      ],
      [
        [0, 0],
        [0, -1],
        [0, -2],
        [0, 1]
      ],
      [
        [0, 0],
        [1, 0],
        [2, 0],
        [-1, 0]
      ]
    ]
  },
  {
    positions: [
      [
        [0, 0],
        [1, 0],
        [0, -1],
        [-1, -1]
      ],
      [
        [0, 0],
        [0, -1],
        [1, -1],
        [1, -2]
      ],
      [
        [0, 0],
        [1, 0],
        [0, -1],
        [-1, -1]
      ],
      [
        [0, 0],
        [0, -1],
        [1, -1],
        [1, -2]
      ]
    ]
  },
  {
    positions: [
      [
        [0, 0],
        [-1, 0],
        [0, -1],
        [1, -1]
      ],
      [
        [1, 0],
        [0, -1],
        [1, -1],
        [0, -2]
      ],
      [
        [0, 0],
        [-1, 0],
        [0, -1],
        [1, -1]
      ],
      [
        [1, 0],
        [0, -1],
        [1, -1],
        [0, -2]
      ]
    ]
  }
];
